import {FaListAlt, FaTrash, FaEye} from "react-icons/fa";
import {FaPencil} from "react-icons/fa6";
import {getUrl} from "../../../constants/urls";

export const webhookListUrl = getUrl("listWebHooks");

export const ACTIONS_LIST = [
  {label: "Delivery_logs", icon: FaListAlt, perms: ["view_webhookdelivery"]},
  {label: "View_Custom_Fields", icon: FaEye, perms: []},
  {label: "Edit", icon: FaPencil, perms: ["change_webhook"]},
  {label: "Delete", icon: FaTrash, perms: ["delete_webhook"]},
];

export const PERMS_FOR_ACTIONS = [];

export const LIST_HEADERS = ["name", "url", "http_method", "ssl_verification"];
